import { serializeEdges } from "./edgeSerializer";
import { serializeNodes } from "./nodeSerializer";
import createGraphSnapshot from "Areas/Documents/graph/utils/createGraphSnapshot";
export const serialize = async ({ graphComponentRef, onlySelection = false }) => {
    const component = createGraphSnapshot(graphComponentRef, onlySelection);
    const jsonGraphModel = {
        Nodes: [],
        Edges: [],
        DataGroups: []
    };
    if (!component)
        return Promise.resolve(jsonGraphModel);
    const { graph } = component;
    component.selection.clear();
    const { groups, nodes } = serializeNodes(graph);
    jsonGraphModel.Nodes = nodes;
    jsonGraphModel.DataGroups = groups;
    jsonGraphModel.Edges = serializeEdges(graph);
    return jsonGraphModel;
};
